import { LanguagesGetResponse } from '@flowio/api-sdk';
import { getLanguagesStatus } from '../selectors';
import ActionTypes from '../constants/ActionTypes';
import ReadyState from '../../../utilities/redux/ReadyState';
import { ThunkDispatcher, RootState, ThunkExtraArguments } from '../../../stores/types';
import { LegacyResponse } from '../../../utilities/clients/types/server';
import standardAction from '../../../utilities/standard-action';
import formatErrorResponseV2 from '../../../utilities/format-error-response-v2';
import toLegacyResponse from '../../../utilities/clients/to-legacy-response';
import { PropType } from '../../../types';

type ResponseType = PropType<LanguagesGetResponse, 'body'>;

export default function fetchLanguages() {
  return (
    dispatch: ThunkDispatcher,
    getState: () => RootState,
    extra: ThunkExtraArguments,
  ): Promise<LegacyResponse<ResponseType> | void> => {
    const state = getState();
    if (getLanguagesStatus(state) === ReadyState.FULFILLED) {
      return Promise.resolve();
    }

    dispatch({
      type: ActionTypes.FETCH_LANGUAGES_REQUEST,
    });

    return extra.api(state).languages.get()
      .then((response) => {
        if (response.ok) {
          dispatch(standardAction(
            ActionTypes.FETCH_LANGUAGES_SUCCESS,
            response.body,
          ));
        } else {
          dispatch(standardAction(
            ActionTypes.FETCH_LANGUAGES_FAILURE,
            formatErrorResponseV2(response),
          ));
        }
        return toLegacyResponse<ResponseType>(response);
      });
  };
}
